import { combineReducers, configureStore } from "@reduxjs/toolkit";
import horseReducer from "./horses/horsesSlice";
import showReducer from "./horses/showsSlice";
import profileReducer from "./horses/profileSlice";
import userReducer from "./user/userSlice";
import eventPassReducer from "./eventpass/eventPassSlice";
import horseProfileReducer from "./horseProfile";
import tableScreenReducer from "./tableScreen/tableScreenSlice";
import selectHorsesReducer from "./eventpass/selectHorsesSlice";
import selectDatesReducer from "./eventpass/selectDatesSlice";

const rootReducer = combineReducers({
  horses: horseReducer,
  shows: showReducer,
  microchip: profileReducer,
  users: userReducer,
  eventPass: eventPassReducer,
  horseProfile: horseProfileReducer,
  tableScreen: tableScreenReducer,
  selectHorses: selectHorsesReducer,
  selectDates: selectDatesReducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
  });
};

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore["dispatch"];

export type StoreRootState = ReturnType<typeof store.getState>;
export default store;
